import React from 'react';
import { Row, Col, Typography } from 'antd';

const { Text } = Typography;

const ItemRow = ({ title, value }) => {
  return (
    <Row style={{ paddingBottom: '8px' }}>
      <Col span={8}>
        <Text style={{ color: '#626D7C', fontSize: '14px', fontWeight: '400' }}>{title}</Text>
      </Col>
      <Col span={16}>
        <Text style={{ color: '#0051A9', fontSize: '14px', fontWeight: '500' }}>{value}</Text>
      </Col>
    </Row>
  );
};

export default ItemRow;
